export default __webpack_public_path__ + "img/refresh_input.9a1fb4bc.svg";